import React, { useRef } from "react";
import useStyles from "./styles";
import clsx from "clsx";

import { TextField, InputAdornment } from "@material-ui/core";
import { Images } from "config/images";

const InputSearchProduct = props => {
	const classes = useStyles();
	const { valueSearch, handleSearchProduct } = props;
	const inputRef = useRef(null);

	return (
		<TextField
			InputProps={{
				startAdornment: (
					<InputAdornment
						position="start"
						className={classes.inputAdornment}
					>
						<img
							src={Images.icMagnifyingGlass}
							alt={Images.icMagnifyingGlass}
							style={{ padding: 7 }}
						/>
					</InputAdornment>
				)
			}}
			inputRef={inputRef}
			defaultValue={valueSearch}
			className={clsx(classes.customInput)}
			placeholder="Tìm sản phẩm bạn muốn mua hôm nay"
			onClick={() => {
				handleSearchProduct();
			}}
		/>
	);
};

export default InputSearchProduct;
